
import { FileTreeNode, SharePointProcessFileResult } from "../models/SharePoint";
import { getRequest, host } from "./apiService";

const sharepointApi = `${host}/api/sharepoint`;

export async function getFiles() {
	return getRequest<FileTreeNode[]>(`${sharepointApi}/list`);
}

export async function getAttachedFileData(fileId: string) {
	return getRequest<SharePointProcessFileResult>(`${sharepointApi}/details/${fileId}`);
}

